import React, { useState } from 'react';

import { useFormState } from '../../../../hooks/useFormState';

import { normalizeMarkdown, prepareMarkdownOnLoad } from '../../../../helpers/normalizeMarkdown';

import { defaultErrorMessage } from '../../../../constants/errorMessages';

import Modal from '../../../../design-system/Modal/Modal';
import ErrorAlert from '../../../../design-system/ErrorAlert/ErrorAlert';
import ModalHeader from '../../../../design-system/ModalHeader/ModalHeader';
import NewRichTextArea from '../../../../design-system/NewRichTextArea/NewRichTextArea';
import { Button } from '../../../../design-system';

const ProvideInformationModal = ({ label, question, answer, setContentItem, onClose }) => {
    const { formData, handleInputChange } = useFormState({ answer: prepareMarkdownOnLoad(answer) });

    const [isLoading, setIsLoading] = useState(false);
    const [errorAlert, setErrorAlert] = useState(null);

    const isAnswerFilled = !!formData.answer;
    const submitButtonState = isLoading ? 'loading' : isAnswerFilled ? 'default' : 'disabled';

    const handleSubmit = async () => {
        if (!isAnswerFilled) return;

        try {
            setIsLoading(true);
            setContentItem((item) => ({ ...item, answer: normalizeMarkdown(formData.answer) }));

            onClose();
        } catch (e) {
            setErrorAlert({ message: defaultErrorMessage, statusCode: e.response?.status });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal size="mediumPlus" resetPadding onClose={onClose}>
            <ModalHeader
                title="Provide more information"
                customPaddings="px-5 py-3"
                outlined
                onClose={onClose}
            />
            <div className="px-5 py-5 flex flex-col gap-6">
                <div className="flex flex-col gap-2">
                    <p className="font-body-bold text-body-bold-s text-neutral-500">
                        Requirement: {label}
                    </p>

                    {question && (
                        <p className="font-body text-body-regular-s text-neutral-500">{question}</p>
                    )}
                </div>

                <NewRichTextArea
                    value={formData.answer}
                    label="Your Answer"
                    isRequired
                    setValue={(value) => handleInputChange('answer', value)}
                    placeholder="Add your answer here!"
                    minHeight={200}
                />
            </div>
            <div className="px-5 py-3 flex justify-end">
                <Button
                    type="secondary"
                    size="sm"
                    text="Save"
                    state={submitButtonState}
                    onClick={handleSubmit}
                />
            </div>

            <ErrorAlert errorAlert={errorAlert} setErrorAlert={setErrorAlert} />
        </Modal>
    );
};

export default ProvideInformationModal;
